import React, { useState } from "react";
import { IconLabel, Drawer } from "ctia-ui";
import BipolarBadge from "components/Badges/BipolarBadge";
import CompanyUsers from "containers/ControlPanel/CompanyUsers";
import ContactLink from "containers/ControlPanel/Orgs/ServiceCenter/ContactLink";
import EditLab from "containers/ControlPanel/Orgs/Labs/EditLab";
import DisableOrg from "containers/ControlPanel/Orgs/DisableOrg/DisableOrg";
import { renderNameWithFlag } from "containers/ControlPanel/Orgs/ServiceCenter/RenderHelperASC";
import { formatATLStatus } from "helpers/AtlHelper";

const OrgLabRow = ({ item }) => {
  const [showBottomDrawer, setShowBottomDrawer] = useState(false);
  const toggleBottomDrawer = () => setShowBottomDrawer(!showBottomDrawer);
  const status = item.active ? "ACTIVE" : "DISABLED";
  const atlStatus = formatATLStatus(item.atlstatus);

  return (
    <tr>
      <td>
        <div>
          <EditLab id={item.id} name={item.name} />
        </div>
        <div>
          <small className="block-left-offset1">
            <strong>
              <span
                className="glow-link cursor-pointer"
                onClick={toggleBottomDrawer}
              >
                <IconLabel awesomeIcon="users" label="View All Users" />
              </span>
            </strong>
          </small>
        </div>
      </td>
      {/* City */}
      <td>{item.citydisplay}</td>
      {/* Country */}
      <td>{renderNameWithFlag(item.countrydisplay, item.country)}</td>
      {/* Contact */}
      <td>
        <ContactLink name={item.contactname} email={item.email} />
      </td>
      {/* ATL */}
      <td>{atlStatus}</td>
      {/* Status */}
      <td>
        <BipolarBadge label={status} positive={item.active === 1} />
      </td>
      <td>
        <DisableOrg org={item} />
        <Drawer
          position="bottom"
          show={showBottomDrawer}
          title="View Lab Users"
          toggleDrawer={toggleBottomDrawer}
          content={
            <CompanyUsers
              companyId={item.id}
              companyName={item.name}
              flagCode={item.country}
            />
          }
          height="400"
        />
      </td>
    </tr>
  );
};

export default OrgLabRow;
